export default "__VITE_ASSET__DIJ4beFe__"